/*
 * Copyright (c) 2025-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/**
 * Polar.sh related constants
 */

// Customer portal URL for managing license activations
export const POLAR_PORTAL_URL = "https://polar.sh/qbitwebui/portal/request"
export const POLAR_CHECKOUT_URL = "https://buy.polar.sh/polar_cl_yyXJesVM9pFVfAPIplspbfCukgVgXzXjXIc2N0I8WcL"
export const POLAR_SANDBOX_CHECKOUT_URL = "https://sandbox-api.polar.sh/v1/checkout-links/polar_cl_5dhqiQBBNaPiCc0sniCocHAJI84X1JCGGI98Y0B7zg5/redirect"
